var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CheckListComponent',{attrs:{"typeName":"巡回清掃 完了一覧","type":2,"claim":false,"settionStrageName":"RoundCheckListStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }